import { LinearProgress, ButtonGroupProps } from "@mui/material";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { InputGrpNumber } from "..";

type Props = {
  className?: string;
  disabled?: boolean;
  minValue?: number;
  maxValue?: number;
  onQuantityChange: (quantity: number) => void;
  product?: any; // Needed by InputGrpNumber, not sure why...
  quantity: number;
  size?: ButtonGroupProps["size"];
};

function QuantityPicker({
  className,
  disabled = false,
  minValue,
  maxValue,
  onQuantityChange,
  product,
  quantity,
  size = "small",
}: Props) {
  const classes = useStyles({ disabled });

  const handleOnQuantityChange = (quantity: number) => {
    onQuantityChange(quantity);
  };

  return (
    <div className={className}>
      <InputGrpNumber
        product={{
          ...product,
          qty: quantity,
        }}
        alsoOnChange={handleOnQuantityChange}
        disableInput={disabled}
        minValue={minValue}
        maxValue={maxValue}
        size={size}
      />
      {!!maxValue && (
        <div className={classes.quantityProgressWrapper}>
          <LinearProgress
            className={classes.quantityProgress}
            value={(quantity / maxValue) * 100}
            variant="determinate"
          />
        </div>
      )}
    </div>
  );
}

export default QuantityPicker;

const useStyles = createUseStyles(() => ({
  quantityProgressWrapper: {
    backgroundColor: "red",
    position: "relative",
    bottom: 4,
    width: "100%",
  },
  quantityProgress: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: (props: { disabled: boolean }) =>
        props.disabled ? theme.color.gray5 : "",
    },
  },
}));
